import React from 'react';
import {
    Panel,
    CloseButton
} from 'components';
import { routes } from 'routes';

import './style.scss';
import { FavoritesList } from './favorites-list';

export interface IFavWindowProps {

}

const FavWindowComponent: React.FC<IFavWindowProps> = (props): JSX.Element => {
    const handleCloseClick = () => {
        routes.goBack(routes.map, { container: 'root' });
    };

    return (
        <Panel className="fav-list-panel">
            <CloseButton onClick={handleCloseClick} />
            <FavoritesList />
        </Panel>
    );
};

export const FavWindow = FavWindowComponent;
